
import { httpRequest } from "../../http";

export class CommandFetchNotebook{
    async run(notebookId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/${notebookId}`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

   
}

